import styled from '@emotion/styled';

const Wrapper = styled('div')`
  display: flex;
  margin-bottom: 3px;
`;

export default Wrapper;
